(function () {
  "use strict";

  console.log("🚀 Janvi Kapoor custom tracking script starting...");

  // =========================================================
  // GLOBAL STATE
  // =========================================================

  const initializedEmbeds = new WeakSet();

  window.dataLayer = window.dataLayer || [];

  // ---------------------------------------------------------
  // WEBENGAGE QUEUE
  // ---------------------------------------------------------

  window.__janviWebEngageQueue =
    window.__janviWebEngageQueue || [];

  window.__janviWebEngageSending =
    window.__janviWebEngageSending || false;

  // =========================================================
  // URL / UTM
  // =========================================================

  const params = new URLSearchParams(
    window.location.search
  );

  const utmFields = {
    utm_source:
      params.get("utm_source") || "",

    utm_medium:
      params.get("utm_medium") || "",

    utm_campaign:
      params.get("utm_campaign") || "",

    utm_term:
      params.get("utm_term") || "",

    utm_content:
      params.get("utm_content") || ""
  };

  // =========================================================
  // SAFE WEBENGAGE TRACKING
  // =========================================================

  function isWebEngageReady() {
    return (
      window.webengage &&
      typeof window.webengage.track === "function"
    );
  }

  // ---------------------------------------------------------
  // ACTUAL WEBENGAGE SEND
  // ---------------------------------------------------------

  function sendWebEngageEvent(eventName, eventData) {
    if (!isWebEngageReady()) {
      return false;
    }

    try {
      console.log(
        "📤 WEBENGAGE SENDING:",
        eventName,
        eventData
      );

      window.webengage.track(
        eventName,
        eventData || {}
      );

      console.log(
        "✅ WEBENGAGE EVENT SENT:",
        eventName
      );

      return true;

    } catch (error) {

      console.error(
        "❌ WEBENGAGE TRACK ERROR:",
        eventName,
        error
      );

      return false;
    }
  }

  // =========================================================
  // QUEUE WEBENGAGE EVENT
  // =========================================================

  function queueWebEngageEvent(
    eventName,
    eventData
  ) {

    console.log(
      "🟡 WEBENGAGE QUEUE:",
      eventName
    );

    window.__janviWebEngageQueue.push({
      eventName: eventName,
      eventData: eventData || {},
      createdAt: Date.now()
    });

    flushWebEngageQueue();

    return true;
  }

  // =========================================================
  // FLUSH WEBENGAGE QUEUE
  // =========================================================

  function flushWebEngageQueue() {

    if (!isWebEngageReady()) {

      console.log(
        "⏳ WebEngage SDK not ready. Queue waiting..."
      );

      return;
    }

    if (
      window.__janviWebEngageSending
    ) {
      return;
    }

    if (
      !window.__janviWebEngageQueue.length
    ) {
      return;
    }

    window.__janviWebEngageSending = true;

    try {

      const queue =
        window.__janviWebEngageQueue.splice(
          0,
          window.__janviWebEngageQueue.length
        );

      console.log(
        "🚀 FLUSHING WEBENGAGE QUEUE:",
        queue
      );

      queue.forEach(function (item) {

        sendWebEngageEvent(
          item.eventName,
          item.eventData
        );

      });

    } catch (error) {

      console.error(
        "❌ WebEngage queue flush error:",
        error
      );

    } finally {

      window.__janviWebEngageSending =
        false;
    }
  }

  // =========================================================
  // WEBENGAGE READY WATCHER
  // =========================================================

  function initializeWebEngageWatcher() {

    let attempts = 0;

    const maxAttempts = 100;

    const watcher =
      setInterval(function () {

        attempts++;

        if (isWebEngageReady()) {

          console.log(
            "🟢 WEBENGAGE SDK READY"
          );

          clearInterval(watcher);

          // -------------------------------------------------
          // WebEngage native ready callback
          // -------------------------------------------------

          try {

            if (
              typeof window.webengage.onReady ===
              "function"
            ) {

              window.webengage.onReady(
                function () {

                  console.log(
                    "🟢 WEBENGAGE onReady FIRED"
                  );

                  flushWebEngageQueue();

                }
              );

            }

          } catch (error) {

            console.warn(
              "⚠️ WebEngage onReady error:",
              error
            );

          }

          // -------------------------------------------------
          // Flush immediately also
          // -------------------------------------------------

          flushWebEngageQueue();

        }

        if (attempts >= maxAttempts) {

          clearInterval(watcher);

          console.warn(
            "⚠️ WebEngage watcher stopped after maximum attempts."
          );

        }

      }, 300);
  }

  initializeWebEngageWatcher();

  // =========================================================
  // WEBENGAGE USER ATTRIBUTE
  // =========================================================

  function setWebEngageUserAttribute(
    attribute,
    value
  ) {

    if (!value) {
      return;
    }

    if (
      !window.webengage ||
      !window.webengage.user ||
      typeof window.webengage.user.setAttribute !==
        "function"
    ) {

      console.warn(
        "⚠️ WebEngage user API not ready:",
        attribute
      );

      return;
    }

    try {

      window.webengage.user.setAttribute(
        attribute,
        String(value)
      );

      console.log(
        "👤 WEBENGAGE ATTRIBUTE SET:",
        attribute,
        value
      );

    } catch (error) {

      console.error(
        "❌ WebEngage setAttribute error:",
        attribute,
        error
      );
    }
  }

  // =========================================================
  // UNLOCK BUTTON SCROLL
  // =========================================================

  document.addEventListener(
    "click",
    function (e) {

      const btn =
        e.target.closest(".unlock-btn");

      if (!btn) {
        return;
      }

      const target =
        document.getElementById(
          "form-box-id"
        );

      if (target) {

        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

      }

    }
  );

  // =========================================================
  // DOM READY
  // =========================================================

  function init() {

    console.log(
      "🚀 Custom tracking initialized"
    );

    let intervalCount = 0;

    const interval =
      setInterval(function () {

        intervalCount++;

        const allEmbeds =
          document.querySelectorAll(
            "shopify-forms-embed#app-embed"
          );

        if (!allEmbeds.length) {

          if (
            intervalCount % 10 === 0
          ) {

            console.log(
              "⏳ Waiting for Shopify Forms..."
            );

          }

          return;
        }

        allEmbeds.forEach(
          function (
            embed,
            embedIndex
          ) {

            if (
              initializedEmbeds.has(embed)
            ) {
              return;
            }

            if (!embed.shadowRoot) {
              return;
            }

            const shadow =
              embed.shadowRoot;

            // =================================================
            // FIND FORM
            // =================================================

            const form =
              shadow.querySelector(
                'form[data-testid="form"]'
              );

            if (!form) {
              return;
            }

            console.log(
              `🔎 Shopify form found [Form ${
                embedIndex + 1
              }]`
            );

            // =================================================
            // UTM FIELDS
            // =================================================

            Object.entries(
              utmFields
            ).forEach(
              function (
                [key, value]
              ) {

                const input =
                  shadow.querySelector(
                    `#custom\\#${key}`
                  );

                if (!input) {
                  return;
                }

                input.value = value;

                input.dispatchEvent(
                  new Event(
                    "input",
                    {
                      bubbles: true,
                      composed: true
                    }
                  )
                );

                input.dispatchEvent(
                  new Event(
                    "change",
                    {
                      bubbles: true,
                      composed: true
                    }
                  )
                );

              }
            );

            // =================================================
            // CITY VALIDATION
            // =================================================

            form.addEventListener(
              "input",
              function (e) {

                const target =
                  e.target;

                if (
                  target.matches(
                    '[id="custom#city_"]'
                  ) ||
                  target.matches(
                    '[name="custom#city_"]'
                  )
                ) {

                  target.value =
                    target.value.replace(
                      /[^a-zA-Z\s]/g,
                      ""
                    );

                }

              }
            );

            // =================================================
            // GET FORM DATA
            // =================================================

            function getFormData() {

              const sr =
                embed.shadowRoot;

              const firstNameEl =
                sr.querySelector(
                  "#first_name"
                );

              const lastNameEl =
                sr.querySelector(
                  "#last_name"
                );

              let full_name = "";

              if (
                firstNameEl ||
                lastNameEl
              ) {

                full_name = [
                  firstNameEl?.value?.trim(),
                  lastNameEl?.value?.trim()
                ]
                  .filter(Boolean)
                  .join(" ");

              }

              const emailEl =
                sr.querySelector(
                  "#email"
                ) ||
                sr.querySelector(
                  'input[type="email"]'
                );

              const phoneEl =
                sr.querySelector(
                  "#phone_number"
                ) ||
                sr.querySelector(
                  'input[type="tel"]'
                );

              const cityEl =
                sr.querySelector(
                  '[id="custom#city_"]'
                ) ||
                sr.querySelector(
                  '[name="custom#city_"]'
                );

              const roleEl =
                sr.querySelector(
                  '[id="custom#role-selector-value"]'
                );

              const data = {

                full_name:
                  full_name || "",

                email:
                  emailEl?.value?.trim() || "",

                phone_number:
                  phoneEl?.value?.trim() || "",

                city:
                  cityEl?.value?.trim() || "",

                wedding_role:
                  roleEl?.textContent?.trim() ||
                  "",

                page_url:
                  window.location.href,

                form_index:
                  embedIndex + 1

              };

              console.log(
                "📦 getFormData():",
                data
              );

              return data;
            }

            // =================================================
            // FORM START EVENT
            // =================================================

            let formStartFired = false;

            form.addEventListener(
              "focusin",
              function () {

                if (formStartFired) {
                  return;
                }

                formStartFired = true;

                console.log(
                  "✅ FORM START EVENT FIRED"
                );

                // ---------------------------------------------
                // WEBENGAGE START
                // ---------------------------------------------

                queueWebEngageEvent(
                  "janvi_kapoor_lead_form_start",
                  {
                    form_name:
                      "janvi_kapoor_lead_form",

                    page_url:
                      window.location.href,

                    form_index:
                      embedIndex + 1
                  }
                );

                // ---------------------------------------------
                // GTM START
                // ---------------------------------------------

                const startEvent = {

                  event:
                    "janvi_kapoor_lead_form_start",

                  user_properties: {

                    form_name:
                      "janvi_kapoor_lead_form",

                    page_url:
                      window.location.href

                  }

                };

                window.dataLayer.push(
                  startEvent
                );

                console.log(
                  "✅ GTM START EVENT FIRED",
                  startEvent
                );

              }
            );

            // =================================================
            // FORM DATA CAPTURE
            // =================================================

            let formDataCaptured =
              false;

            // =================================================
            // FIND SUBMIT BUTTON
            // =================================================

            function findSubmitButton() {

              const buttons =
                shadow.querySelectorAll(
                  "button, input[type='submit']"
                );

              for (
                const button of buttons
              ) {

                const text =
                  (
                    button.innerText ||
                    button.textContent ||
                    button.value ||
                    ""
                  )
                    .trim()
                    .toLowerCase();

                if (
                  text.includes(
                    "book appointment"
                  ) ||
                  text.includes(
                    "book an appointment"
                  ) ||
                  text.includes(
                    "submit"
                  )
                ) {

                  return button;
                }
              }

              return null;
            }

            // =================================================
            // BUTTON CLICK HANDLER
            // =================================================

            function attachButtonListener() {

              const button =
                findSubmitButton();

              if (!button) {
                return false;
              }

              if (
                button.dataset
                  .janviTrackingAttached ===
                "true"
              ) {

                return true;
              }

              button.dataset
                .janviTrackingAttached =
                "true";

              console.log(
                "🎯 Book Appointment button found",
                button
              );

              button.addEventListener(
                "click",
                function () {

                  console.log(
                    "🟡 BOOK APPOINTMENT CLICK DETECTED"
                  );

                  // -------------------------------------------
                  // CAPTURE FORM DATA
                  // -------------------------------------------

                  const data =
                    getFormData();

                  // -------------------------------------------
                  // STORE DATA
                  // -------------------------------------------

                  embed._shopifyFormData =
                    data;

                  window._janviShopifyFormData =
                    data;

                  formDataCaptured =
                    true;

                  console.log(
                    "💾 FORM DATA STORED:",
                    data
                  );

                  console.log(
                    "⏳ Waiting for Shopify Thank You screen..."
                  );

                },
                true
              );

              return true;
            }

            // =================================================
            // THANK YOU STATE
            // =================================================

            let thankYouFired =
              false;

            // =================================================
            // SEND FINAL WEBENGAGE CONVERSION
            // =================================================

            function sendFinalWebEngage(
              data
            ) {

              if (!data) {

                console.error(
                  "❌ Cannot send WebEngage: data missing"
                );

                return false;
              }

              console.log(
                "🔥 PREPARING WEBENGAGE FINAL EVENT:",
                data
              );

              // ---------------------------------------------
              // USER ATTRIBUTES
              // ---------------------------------------------

              setWebEngageUserAttribute(
                "full_name",
                data.full_name
              );

              setWebEngageUserAttribute(
                "email",
                data.email
              );

              setWebEngageUserAttribute(
                "phone",
                data.phone_number
              );

              setWebEngageUserAttribute(
                "city",
                data.city
              );

              setWebEngageUserAttribute(
                "wedding_role",
                data.wedding_role
              );

              // ---------------------------------------------
              // FINAL EVENT
              // ---------------------------------------------

              const eventData = {

                form_name:
                  "janvi_kapoor_lead_form",

                full_name:
                  data.full_name,

                email:
                  data.email,

                phone:
                  data.phone_number,

                phone_number:
                  data.phone_number,

                city:
                  data.city,

                wedding_role:
                  data.wedding_role,

                page_url:
                  data.page_url,

                form_index:
                  data.form_index

              };

              queueWebEngageEvent(
                "janvi_kapoor_lead_form_submit",
                eventData
              );

              return true;
            }

            // =================================================
            // THANK YOU DETECTION
            // =================================================

            function checkThankYou() {

              if (thankYouFired) {
                return;
              }

              const currentShadow =
                embed.shadowRoot;

              if (!currentShadow) {
                return;
              }

              const shadowText =
                (
                  currentShadow.textContent ||
                  ""
                )
                  .replace(/\s+/g, " ")
                  .trim();

              const thankYouFound =
                shadowText.includes(
                  "Thank you for registering."
                ) ||
                shadowText.includes(
                  "Thank you for registering"
                );

              if (!thankYouFound) {
                return;
              }

              console.log(
                "🎉 THANK YOU SCREEN DETECTED"
              );

              // ---------------------------------------------
              // GET STORED DATA
              // ---------------------------------------------

              const data =
                embed._shopifyFormData ||
                window._janviShopifyFormData;

              if (!data) {

                console.error(
                  "❌ Thank You found but FORM DATA is missing"
                );

                /*
                 * IMPORTANT:
                 * Do NOT set thankYouFired here.
                 * We want another attempt.
                 */

                return;
              }

              console.log(
                "🔥 FINAL CONVERSION DATA:",
                data
              );

              // ---------------------------------------------
              // MARK FIRED ONLY AFTER DATA EXISTS
              // ---------------------------------------------

              thankYouFired = true;

              // =================================================
              // WEBENGAGE
              // =================================================

              sendFinalWebEngage(
                data
              );

              // =================================================
              // GTM / DATALAYER
              // =================================================

              window.dataLayer =
                window.dataLayer || [];

              const gtmEvent = {

                event:
                  "janvi_kapoor_lead_form_submit",

                form_name:
                  "janhvi_kapoor_form",

                campaign_name:
                  "ikjk_iktara",

                lead_type:
                  "bridal_consultation",

                submission_method:
                  "website_form",

                full_name:
                  data.full_name,

                email:
                  data.email,

                phone_number:
                  data.phone_number,

                city:
                  data.city,

                wedding_role:
                  data.wedding_role,

                page_url:
                  data.page_url,

                form_index:
                  data.form_index

              };

              window.dataLayer.push(
                gtmEvent
              );

              console.log(
                "✅ GTM CONVERSION EVENT FIRED",
                gtmEvent
              );

              console.log(
                "📊 dataLayer:",
                window.dataLayer
              );
            }

            // =================================================
            // MUTATION OBSERVER
            // =================================================

            const thankYouObserver =
              new MutationObserver(
                function () {

                  checkThankYou();

                }
              );

            thankYouObserver.observe(
              shadow,
              {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true
              }
            );

            console.log(
              `👀 THANK YOU OBSERVER ATTACHED [Form ${
                embedIndex + 1
              }]`
            );

            // =================================================
            // THANK YOU FALLBACK POLLING
            // =================================================

            const thankYouInterval =
              setInterval(
                function () {

                  if (
                    thankYouFired
                  ) {

                    clearInterval(
                      thankYouInterval
                    );

                    return;
                  }

                  checkThankYou();

                  if (
                    thankYouFired
                  ) {

                    clearInterval(
                      thankYouInterval
                    );

                  }

                },
                300
              );

            // =================================================
            // BUTTON FIND RETRY
            // =================================================

            const buttonInterval =
              setInterval(
                function () {

                  if (
                    attachButtonListener()
                  ) {

                    clearInterval(
                      buttonInterval
                    );

                  }

                },
                300
              );

            // Immediate attempt
            attachButtonListener();

            // =================================================
            // CUSTOM BENEFITS
            // =================================================

            const p =
              shadow.querySelector(
                "._textBody_2aowh_10 p"
              );

            if (
              p &&
              !shadow.querySelector(
                ".benefits-wrapper"
              )
            ) {

              p.insertAdjacentHTML(
                "afterend",
                `
                  <div class="benefits-wrapper">

                    <div class="benefits-inner b1">
                      <img
                        src="https://ik.imagekit.io/4sjmoqtje/Digital-Lookbook.jpg"
                        alt=""
                      >
                      <span>
                        Digital<br>Lookbook
                      </span>
                    </div>

                    <div class="benefits-inner b2">
                      <img
                        src="https://ik.imagekit.io/4sjmoqtje/e-Wedding-Planner.jpg"
                        alt=""
                      >
                      <span>
                        E-Wedding<br>Planner
                      </span>
                    </div>

                    <div class="benefits-inner b3">
                      <img
                        src="https://ik.imagekit.io/4sjmoqtje/Personalized-stylist.jpg"
                        alt=""
                      >
                      <span>
                        Personalized<br>
                        Stylist Consultation
                      </span>
                    </div>

                  </div>
                `
              );

            }

            // =================================================
            // CUSTOM CSS
            // =================================================

            if (
              !shadow.querySelector(
                'style[data-custom-style]'
              )
            ) {

              const style =
                document.createElement(
                  "style"
                );

              style.setAttribute(
                "data-custom-style",
                "true"
              );

              style.textContent = `

                .benefits-wrapper {
                  display: flex;
                  width: 100%;
                  justify-content: center;
                  align-items: flex-start;
                  gap: 10px;
                  margin-top: 10px;
                  padding: 10px 0;
                  border-top: 1px solid rgba(107,45,60,0.12);
                  border-bottom: 1px solid rgba(107,45,60,0.12);
                }

                .benefits-inner {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;
                  width: 33%;
                  gap: 5px;
                }

                .benefits-inner span {
                  font-size: 12px;
                  line-height: 1;
                }

                .benefits-wrapper .b1,
                .benefits-wrapper .b2 {
                  width: 23%;
                }

                .benefits-inner img {
                  width: 40px;
                }

                .shopify-block.shopify-app-block {
                  padding-top: 20px;
                  padding-bottom: 20px;
                }

                h2._textHeading_2aowh_35 {
                  font-family: var(--font-noto-serif-display) !important;
                  font-size: 20px !important;
                }

                ._formHeader_jnbzb_24 p strong {
                  display: block;
                  margin-top: 10px;
                }

                ._formHeader_jnbzb_24 p {
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: center;
                }

                ._formHeader_jnbzb_24 p strong:first-child {
                  width: 30%;
                  box-sizing: border-box;
                }

                ._formHeader_jnbzb_24 p strong:nth-child(2) {
                  width: 23%;
                }

                ._formHeader_jnbzb_24 p strong:nth-child(3) {
                  width: 40%;
                }

                section._formHeader_jnbzb_24 {
                  margin-bottom: 5px !important;
                }

                section form._formFieldset_jnbzb_92 {
                  flex-direction: unset;
                  flex-wrap: wrap;
                }

                section form._formFieldset_jnbzb_92 > * {
                  width: 100%;
                }

                section form._formFieldset_jnbzb_92
                ._formFieldContainer_1mxsl_5:nth-child(5),

                section form._formFieldset_jnbzb_92
                ._selectContainer_12thd_6:nth-child(6) {
                  width: 47.5%;
                }

                section form._formFieldset_jnbzb_92
                ._formFieldContainer_1mxsl_5:nth-child(5):before {

                  content: "City *";
                  text-transform: none;
                  font: var(--forms-body-font);
                  -webkit-font-smoothing: antialiased;
                  line-height: 20px;
                  color: var(--body-text-color);
                  margin: 0;
                  margin-block: 0 !important;
                  display: block;
                  padding-bottom: 10px;

                }

                section form._formFieldset_jnbzb_92
                ._formFieldContainer_1mxsl_5:nth-child(5) label {
                  top: 45px !important;
                }

                @media only screen and (max-width: 767px) {

                  ._formHeader_jnbzb_24 p strong {
                    width: 100% !important;
                    margin-top: 5px;
                  }

                  h2._textHeading_2aowh_35 {
                    font-size: 18px !important;
                  }

                }

                @media only screen and (max-width: 375px) {

                  section form._formFieldset_jnbzb_92
                  ._formFieldContainer_1mxsl_5:nth-child(5),

                  section form._formFieldset_jnbzb_92
                  ._selectContainer_12thd_6:nth-child(6) {
                    width: 47%;
                  }

                }

              `;

              shadow.appendChild(
                style
              );

              // ---------------------------------------------
              // REMOVE UTM FIELDS
              // ---------------------------------------------

              [
                "utm_source",
                "utm_medium",
                "utm_campaign",
                "utm_term",
                "utm_content"
              ].forEach(
                function (field) {

                  const input =
                    shadow.querySelector(
                      `#custom\\#${field}`
                    );

                  if (input) {

                    input
                      .closest(
                        "._formFieldContainer_1mxsl_5"
                      )
                      ?.remove();

                  }

                }
              );
            }

            // =================================================
            // MARK INITIALIZED
            // =================================================

            initializedEmbeds.add(
              embed
            );

            console.log(
              `✅ CUSTOM EMBED ${
                embedIndex + 1
              } INITIALIZED`
            );

          }
        );

        // =====================================================
        // STOP MAIN INITIALIZATION INTERVAL
        // =====================================================

        const currentEmbeds =
          document.querySelectorAll(
            "shopify-forms-embed#app-embed"
          );

        let initializedCount = 0;

        currentEmbeds.forEach(
          function (embed) {

            if (
              initializedEmbeds.has(
                embed
              )
            ) {

              initializedCount++;

            }

          }
        );

        if (
          initializedCount ===
          currentEmbeds.length
        ) {

          clearInterval(
            interval
          );

          console.log(
            `✅ ALL ${
              currentEmbeds.length
            } EMBEDS INITIALIZED`
          );

        }

      }, 300);
  }

  // =========================================================
  // DOM READY
  // =========================================================

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      init
    );

  } else {

    init();

  }

})();